import { useEffect, useState } from "react";
import api from "../../../services/api";
import toast from "react-hot-toast";

export default function Xml({ user }) {
  const [isLoading, setIsLoading] = useState(false);
  const [xmlContent, setXmlContent] = useState("");

  useEffect(() => {
      fetchXmlContent();
  }, [user]);

  const fetchXmlContent = async () => {
    setIsLoading(true);
    try {
      const response = await api.download("/meeting_xml", { user_id: user._id });
      const xmlText = await response.text();
      setXmlContent(xmlText);
    } catch (error) {
      console.error("Error fetching XML:", error);
      toast.error("Error loading XML report");
    } finally {
      setIsLoading(false);
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    toast.success("Copied to clipboard");
  };

  if (isLoading) {
    return (
      <div className="p-6">
        <div className="text-center">
          <div className="text-lg font-semibold mb-2">Loading XML report...</div>
          <div className="text-sm text-gray-600">Fetching XML content...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="mb-4">
        <h1 className="text-xl font-bold">XML Meeting Report</h1>
      </div>

      {xmlContent && (
        <div className="mb-6">
          <div className="flex items-center justify-between mb-2">
            <h2 className="text-lg font-semibold">Complete XML Report (with Budget Issues)</h2>
            <button
              onClick={() => copyToClipboard(xmlContent)}
              className="text-gray-500 hover:text-gray-700"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
            </button>
          </div>
          <pre className="bg-gray-100 p-4 rounded text-xs text-gray-800 whitespace-pre-wrap">{xmlContent}</pre>
        </div>
      )}
    </div>
  );
}